import { Component, Input, OnInit, inject, DestroyRef, OnChanges, SimpleChanges, ViewChild, effect } from '@angular/core';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash'
import { ScoreWidgetComponent } from '../../../../../../shared/components/score/score-widget/score-widget.component';
import { NgIf } from '@angular/common';
import { LtmsBarChartViewComponent } from '../../../../../../shared/components/graph/ltms-bar-chart-view/ltms-bar-chart-view.component';
import { LtmsErrorComponent } from '../../../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../../../shared/components/ltms-loader/ltms-loader.component';

@Component({
    selector: 'app-action-summary-bar-chart',
    templateUrl: './action-summary-bar-chart.component.html',
    styleUrls: ['./action-summary-bar-chart.component.scss'],
    imports: [ScoreWidgetComponent, NgIf, LtmsBarChartViewComponent, LtmsErrorComponent, LtmsLoaderComponent]
})
export class ActionSummaryBarChartComponent implements OnInit, OnChanges {
  destroyRef = inject(DestroyRef);
  title: string = 'Trends - ';
  description: string = 'Click the full screen icon to explore complete trend details for solved and unsolved issues.';
  @Input() componentId: string = "ltms-category-" + this.getTimeStamp()
  @Input() filters: any = []
  @ViewChild(ScoreWidgetComponent) scoreWidgetComponent!: ScoreWidgetComponent;

  chartId: string = "ltms-bar-chart-" + this.getTimeStamp()
  chartStaticId: string = 'ltms-count-category-chart'
  widgetConfig: any = {
    "elementId": "ltms-widget-for-category-chart",
    "trendSelector": true,
    "viewSelector": {
      enable: true,
      type: 'chart'
    },
    "download": {
      enable: true,
      componentId: this.chartStaticId,
      data: {        
        "fileName": '',
        "title": '',
        "columns": [
          {
            order: 1,
            header: "Date",
            dataKey: "time",
            uniqueId: 'time'
          },
          {
            order: 2,
            header: "Total",
            dataKey: "total_count_with_percentage",
            uniqueId: 'total_count_with_percentage'
          }
        ],
        "rows": []
      }
    },
    "fullscreen": {
      enable: true,
      componentId: this.componentId
    },
  };
  xAxis: any = {
    "title": {
      "padding": 0,
      "display": true,
      "text": "",
      "font": {
        "family": "Asap"
      },
      "color": "#7f7f7f"
    }
  };
  yAxis: any = {
    "title": {
      "padding": 0,
      "display": true,
      "text": "",
      "font": {
        "family": "Asap",
      },
      "color": "#7f7f7f"
    }
  };
  exportsData: any = [];
  dateFilterField = _.get(Helpers, 'datePicker.dateFilterType', 1) == 1 ? "feedback_request_date" : "created_date";
  loadingScoreTrend: boolean = false;
  scoreTrendDataAvailable: boolean = false;
  activeTabLabel: string = "- Average TAT (Hours)"
  chartData: any = {
    chartId: this.chartStaticId,
    xAxis: {},
    yAxis: {},
    chart: {
      title: '',
      description: '',
      trendType: 'Monthly',
      xValues: [],
      hiddenValues: [],
      yValues: [],
      gradientColors: ["#301A4B", "#301A4B0F"],
      borderColor: '#301A4B',
      pointBorderColor: 'white',
      pointBackgroundColor: '#301A4B',
      pointHoverBackgroundColor: '#301A4B'
    },
    enable_click: true
  }
  dataSource: any = {}
  universalFilter: any = {}
  selectedTrendType: any = {};
  showPercentage: boolean = false;
  errorCode: string = '404';
  isDataAvailable: boolean = false;
  startDate: any = '';
  hierarchyStack: any = [];
  endDate: any = '';
  isRequestDate: any = '';
  isDataLoaded: boolean = false;
  isDateRangeChange: boolean = false;
  brandDetail: any = {};
  isFullScreen: boolean = false;
  accountDetails: any = {};

  scoreWidget(type: string): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true,
      isTrendDropdownShow: true,
      isAbsoluteChartShow: true,
      isPercenttageChartShow: true
    };
  }

  constructor(
    public _actionService: ActionService,
    private _analytics: ResponseAnalyticsService,
    private _helpers: HelpersService,
    private _appStateService: AppStateService
  ) {
    effect(()=>{
      if (this._appStateService.initialized()) {
        this.universalFilter = this._appStateService.universalFilter()
        this.hierarchyStack = this._appStateService.hierarchyStack();
        const datePicker:any = this._appStateService.datePicker()
        this.isRequestDate = datePicker.isRequestDate
        this.getTrendsData(this.selectedTrendType);
      }
    })
    // Add event listeners for Escape key and click outside
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
   }

  ngOnInit(): void {
    this._helpers.appState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((state: any) => {
      if (state && !state.pending) {
        this.widgetConfig.elementId = "ltms-widget-for-category-chart";
        this.isDateRangeChange = true;
        this.startDate = state.datePicker.startDate;
        this.universalFilter = state.universalFilter ? state.universalFilter : {};
        this.endDate = state.datePicker.endDate;
        this.brandDetail = state.brandDetails
        this.accountDetails = state.accountDetails
        this.hierarchyStack = state.hierarchyStack
        this.title = (state.hierarchyStack && state.hierarchyStack.length) ? 'Trend - ' + state.hierarchyStack[0].group_key[0] : 'Trend - '+this.brandDetail.name;
        this.isRequestDate = state.datePicker.isRequestDate;
        this.initCompnent();
      }
    })
  }

  initCompnent() {
    // this.onTrendTypeChange(this.selectedTrendType)
  }

  onDownload() {
    let downloadConfig: any = {
      dataKey: 'uniqueId',
      headerKey: 'header',
      data: [{
        columns: [
          {
            order: 1,
            header: "Date",
            dataKey: "time",
          },
          {
            order: 2,
            header: "Total",
            dataKey: "total_count_with_percentage"
          }
        ],
        rows: this.exportsData
      }]
    }
    
    downloadConfig.fileDetails = {
      title: "Action Trend - Status Overview " + this.selectedTrendType.name,
      fileName: "Action Trend - Status Overview " + this.selectedTrendType.name,
      accountName: this.accountDetails.display_name || this.accountDetails.name,
      brandName: this.brandDetail.display_name || this.brandDetail.name
    }

    if (downloadConfig.data.length) {
      this._analytics.prepareAndDownloadData(downloadConfig);
    }
  }

  onFullScreen (event: any) {
    this.isFullScreen = event;
  }

     // Method to handle Escape key press
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isFullScreen) {
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  // Method to handle clicks outside the content
  handleClickOutside(event: MouseEvent) {
    const overlayElements = document.getElementsByClassName('fullscreen'); // Get all elements with the overlay class
    const contentElements = document.getElementsByClassName('action-category-container'); // Get all elements with the content class

    // Check if the clicked element is the overlay
    const isOverlayClick = Array.from(overlayElements).some(overlay => overlay.contains(event.target as Node));
    const isContentClick = Array.from(contentElements).some(content => content.contains(event.target as Node));

    if (this.isFullScreen && isOverlayClick && !isContentClick) { // Only exit fullscreen if the overlay is clicked
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  ngOnDestroy(): void {
    // Remove event listeners and reset
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters'] && !_.isEmpty(this.filters) && _.has(this.filters, 'filters')) {
      this.onTrendTypeChange(this.selectedTrendType, true);
    }
  }
  
  getTimeStamp() {
    return new Date().getTime()
  }

  onTrendTypeChange(trendType: any, drillDownEnabled:any) {
    if(this.isDateRangeChange && !_.isEmpty(trendType) || (trendType.trend_type != this.selectedTrendType.trend_type) || drillDownEnabled){
      this.selectedTrendType = trendType;
      this.getTrendsData(trendType);
      if (!_.isEmpty(this.filters) && !_.isEmpty(this.filters.filters) && this.filters.groupKeyAlias) {
        _.each(this.filters.filters, (filter) => {
          if (filter && filter.field_id == this.filters.groupKeyAlias) {
            this.title = 'Trend - ' + filter.field_value
          } else {
            this.title = (this.hierarchyStack && this.hierarchyStack.length) ? 'Trend - ' + this.hierarchyStack[0].group_key[0] : 'Trend - '+this.brandDetail.name;
          }
        })
      } else {
        this.title = (this.hierarchyStack && this.hierarchyStack.length) ? 'Trend - ' + this.hierarchyStack[0].group_key[0] : 'Trend - '+this.brandDetail.name;
      }
      this.widgetConfig['download']['data']['fileName'] = "Action Trend - Count" + " " + trendType.name
      this.widgetConfig['download']['data']['title'] = "Action Trend - Count" + " - " + trendType.name
      this.isDateRangeChange = false;
    }
  }

  onViewChange(event: any) {
    this.showPercentage = event
    if (this.showPercentage) {
      this.chartData.yAxis.title.text = "Percentage of Cases";
      this.chartData.chart.yValues = [{
        label: "Solved",
        borderColor: "#136B8D",
        backgroundColor: '#136B8D',
        data: this.dataSource.percent.resolved
      }, {
        label: "Unsolved",
        borderColor: "#F3B34D",
        backgroundColor: '#F3B34D',
        data: this.dataSource.percent.unresolved
      }]
    } else {
      this.chartData.yAxis.title.text = "Count of Cases";
      this.chartData.chart.yValues = [{
        label: "Solved",
        borderColor: "#136B8D",
        backgroundColor: '#136B8D',
        data: this.dataSource.resolved
      }, {
        label: "Unsolved",
        borderColor: "#F3B34D",
        backgroundColor: '#F3B34D',
        data: this.dataSource.unresolved
      }]
    }
    this.chartId = "ltms-bar-chart-" + this.getTimeStamp()
  }

  // to block multiple api calling
  checkRequiredParameter(params:any){
    if(params && _.hasIn(params,'trend_type') && !_.isEmpty(params.from) && !_.isEmpty(params.to)){
      return true
    }else{
      return false
    }
  }

  getTrendsData(trendType?: any) {
    this.isDataLoaded = false;
    let params = this._actionService.getTrendsRequestParams({
      dateFilterField: this.isRequestDate ? "feedback_request_date" : "created_date",
      trendType: trendType.trend_type,
      appliedfilters: _.get(this.filters, 'filters', [])
    })

    params.action_type = 'summary'
    params.universal_filter = this.universalFilter;
    params.group_key_alias = _.get(this.filters, 'groupKeyAlias', 'brands');
    params.actionable_filter = _.get(this.brandDetail, "action_management_configuration.actionables", {});
    params.age_type = _.get(this.brandDetail, "action_management_configuration.ageing_config.type", 1);
    params.turnaround = _.get(this.brandDetail, "action_management_configuration.ageing_config.turnaround_time", 0);
    if(this.checkRequiredParameter(params)){
      this._actionService.getTrendsData(params).subscribe({
        next: (response) => {
          if (this.validateApiResponse(response)) {
            const trendData = _.get(response, 'data.response', [])
            this.dataSource = this._actionService.processTrendsData(trendData);
            const fieldsToExport = this.getExportsFields(trendType.name)
            this.exportsData = this._actionService.prepareDataForExport(trendData, fieldsToExport)

            this.chartData.chart.tooltipFields = fieldsToExport
            this.chartData.chart.tooltipData = this.exportsData

            this.chartData.chart.xValues = this.dataSource.timestamp
            this.chartData.xAxis = this.xAxis;
            this.chartData.yAxis = this.yAxis;
            this.chartData.xAxis.title.text = this.isRequestDate ? "Request Date" : "Response Date";
            this.chartData.yAxis.title.text = "Count of Cases";
            this.chartData.chart.trendType = trendType.name
            this.chartData.chart.yValues = [{
              label: "Solved",
              borderColor: "#136B8D",
              backgroundColor: '#136B8D',
              data: this.dataSource.resolved
            }, {
              label: "Unsolved",
              borderColor: "#F3B34D",
              backgroundColor: '#F3B34D',
              data: this.dataSource.unresolved
            }]

            this.widgetConfig.download.data.rows = this.exportsData;
            this.chartId = "ltms-bar-chart-" + this.getTimeStamp()
            this.isDataAvailable = true;
            this.isDataLoaded = true;
          }
          else {
            this.isDataAvailable = false;
            this.isDataLoaded = true;
          }
        },
        error: (err) => {
          this.isDataAvailable = false;
          this.isDataLoaded = true;
          if (err.status == '500') {
            this.errorCode = '500'
          } else if (err.status == "404") {
            this.errorCode = '404'
          } else if (err.status == "408") {
            this.errorCode = '408'
          }
        }
      })
    }
  }
  validateApiResponse(response: any) {
    return (response.code == 0 && _.hasIn(response, 'data.response') && !_.isEmpty(response.data.response))
  }
  getExportsFields(trendType: string) {
    const fieldsToExport: any = [{
      header: "Date",
      dataKey: "time",
      type: "date",
      defaultValue: "",
      order: "1",
      trendType: trendType,
      addInTooltip: false,
      showPercentage: false,
      format: ""
    }, {
      header: "Total",
      dataKey: "total_count",
      addInTooltip: true,
      showPercentage: true,
      totalKey: "total_count",
      type: "number",
      order: "2",
      defaultValue: 0,
      format: ""
    }, {
      header: "Solved",
      dataKey: "resolved",
      type: "number",
      order: "3",
      addInTooltip: false,
      showPercentage: true,
      totalKey: "total_count",
      defaultValue: 0,
      format: ""
    }, {
      header: "Unsolved",
      dataKey: "unresolved",
      addInTooltip: false,
      showPercentage: true,
      totalKey: "total_count",
      type: "number",
      order: "4",
      defaultValue: 0,
      display_format: ""
    }]
    return fieldsToExport
  }

  onChartClick(data: any) {
    const dateObject = data.dateRange
    dateObject.isCustomDateRangeSelected = true
    this._helpers.setDatePicker(data.dateRange)
  }
}
